import { axiosInstance } from "../axiosUtil";

import getAuthHeader from "../Auth/GetAuthHeader";

class AudioFileService {
  getAudioFileInfo(account_ids) {
    const headers = {
      Authorization: getAuthHeader(),
    };
    const queryParams = "account_id=" + account_ids.join("&account_id=");
    if (Array.isArray(account_ids) && account_ids.length > 0) {
      return axiosInstance
        .get(`api/v1/account/audio/info?${queryParams}`, { headers })
        .then((response) => {
          return response.data;
        });
    }

    return Promise.reject();
  }

  approveAudioFile(accountId, audioFileId) {
    const headers = {
      Authorization: getAuthHeader(),
    };

    return axiosInstance
      .put(`api/v1/account/${accountId}/audio/approve/${audioFileId}`, {
        headers,
      })
      .then((response) => {
        return response.data;
      });
  }

  rejectAudioFile(accountId, audioFileId, { reason, comments }) {
    const headers = {
      Authorization: getAuthHeader(),
    };

    return axiosInstance
      .put(`api/v1/account/${accountId}/audio/reject/${audioFileId}`, {
        headers,
        data: {
          rejection_reason: reason,
          comments,
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  getVTAudioFileInfo(url = "") {
    if (!url) {
      url = "/api/v1/account/audio/voice_talent";
    }

    const headers = {
      Authorization: getAuthHeader(),
    };

    return axiosInstance.get(url, { headers }).then((response) => {
      return response.data;
    });
  }
}

export default new AudioFileService();
